import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { PrivilegeService } from 'api';
import { getPrivilegesRequestId } from 'api/privileges/getCustomerPrivileges';
import { SecondaryButton } from 'components/Button';
import useHandleUser from 'hooks/user/useHandleUser';
import dateTimeFormatter from 'utils/date/dateTimeFormatter';
import useStyles from './AccessStyles';
export default function PrivilegeRow({
  privilege
}) {
  const {
    privilege: privilegeClass,
    column,
    emailColumn,
    conditionalColumn
  } = useStyles();
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const {
    enqueueSnackbar
  } = useSnackbar();
  const setPrivilegeRequestId = useSetRecoilState(getPrivilegesRequestId);
  const user = useHandleUser();
  const revokeAccess = async () => {
    if (!privilege.id) return;
    setLoading(true);
    try {
      await PrivilegeService.revokePrivilege({
        privilegeId: privilege.id,
        body: {
          reason: ''
        }
      });
      enqueueSnackbar(t('access_management.access_revoked'), {
        variant: 'success'
      });
    } catch {
      enqueueSnackbar(t('access_management.revoke_access_failed'), {
        variant: 'error'
      });
    }
    setPrivilegeRequestId(id => id + 1);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: privilegeClass
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(column, emailColumn)
  }, privilege.receiverEmail), /*#__PURE__*/React.createElement("div", {
    className: clsx(column, conditionalColumn)
  }, dateTimeFormatter(privilege.validFrom)), /*#__PURE__*/React.createElement("div", {
    className: column
  }, user?.id !== privilege.userId && /*#__PURE__*/React.createElement(SecondaryButton, {
    ariaLabel: "revoke-access",
    onClick: revokeAccess,
    outlined: true,
    loading: loading
  }, t('access_management.revoke_access'))));
}